import React from 'react';
import { Phone, FileText, CheckCircle, ExternalLink, Heart } from 'lucide-react';
export function MedicalCardInfoPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-3196">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-3197">
        <div className="container mx-auto px-4" data-id="element-3198">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-3199">
            Medical Certificate
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-3200">
            Physical Qualifications for Commercial Motor Vehicle Drivers
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-3201">
        <div className="max-w-4xl mx-auto" data-id="element-3202">
          {/* General Information */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3203">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-3204">
              General Information
            </h2>

            <div className="space-y-6" data-id="element-3205">
              <div className="bg-red-50 border-l-4 border-red-500 p-6" data-id="element-3206">
                <h3 className="font-bold text-gray-900 mb-3" data-id="element-3207">
                  §391.11(a) Basic Requirement
                </h3>
                <p className="text-gray-700" data-id="element-3208">
                  A person shall not drive a commercial motor vehicle unless
                  he/she is qualified to drive a commercial motor vehicle.
                  Except as provided in §391.63, a motor carrier shall not
                  require or permit a person to drive a commercial motor vehicle
                  unless that person is qualified to drive a commercial motor
                  vehicle.
                </p>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-3209">
                <h3 className="font-bold text-gray-900 mb-4" data-id="element-3210">
                  §391.11(b) Qualification Requirements
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3211">
                  Except as provided in Subpart G of this part, a person is
                  qualified to drive a motor vehicle if he/she:
                </p>
              </div>

              <div className="space-y-4" data-id="element-3212">
                <div className="bg-white border-2 border-blue-500 rounded-lg p-6" data-id="element-3213">
                  <div className="flex items-start" data-id="element-3214">
                    <span className="bg-blue-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3215">
                      (1)
                    </span>
                    <div data-id="element-3216">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3217">
                        Age Requirement
                      </p>
                      <p className="text-gray-700" data-id="element-3218">
                        Is at least <strong data-id="element-3219">21 years old</strong>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-green-500 rounded-lg p-6" data-id="element-3220">
                  <div className="flex items-start" data-id="element-3221">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3222">
                      (2)
                    </span>
                    <div data-id="element-3223">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3224">
                        English Language Proficiency
                      </p>
                      <p className="text-gray-700" data-id="element-3225">
                        Can read and speak the English language sufficiently to:
                      </p>
                      <ul className="mt-2 space-y-1 text-gray-700 ml-4" data-id="element-3226">
                        <li data-id="element-3227">• Converse with the general public</li>
                        <li data-id="element-3228">
                          • Understand highway traffic signs and signals in
                          English
                        </li>
                        <li data-id="element-3229">• Respond to official inquiries</li>
                        <li data-id="element-3230">• Make entries on reports and records</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-yellow-500 rounded-lg p-6" data-id="element-3231">
                  <div className="flex items-start" data-id="element-3232">
                    <span className="bg-yellow-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3233">
                      (3)
                    </span>
                    <div data-id="element-3234">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3235">
                        Experience & Training
                      </p>
                      <p className="text-gray-700" data-id="element-3236">
                        Can, by reason of experience, training, or both, safely
                        operate the type of commercial motor vehicle he/she
                        drives
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-red-500 rounded-lg p-6" data-id="element-3237">
                  <div className="flex items-start" data-id="element-3238">
                    <span className="bg-red-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3239">
                      (4)
                    </span>
                    <div data-id="element-3240">
                      <p className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-3241">
                        <Heart className="mr-2 text-red-600" size={20} data-id="element-3242" />
                        Physical Qualifications
                      </p>
                      <p className="text-gray-700" data-id="element-3243">
                        Is physically qualified to drive a commercial motor
                        vehicle in accordance with{' '}
                        <strong data-id="element-3244">
                          Subpart E — Physical Qualifications and Examinations
                        </strong>{' '}
                        of this part
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-purple-500 rounded-lg p-6" data-id="element-3245">
                  <div className="flex items-start" data-id="element-3246">
                    <span className="bg-purple-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3247">
                      (5)
                    </span>
                    <div data-id="element-3248">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3249">
                        Valid License
                      </p>
                      <p className="text-gray-700" data-id="element-3250">
                        Has a currently valid commercial motor vehicle
                        operator's license issued only by{' '}
                        <strong data-id="element-3251">one State or jurisdiction</strong>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-indigo-500 rounded-lg p-6" data-id="element-3252">
                  <div className="flex items-start" data-id="element-3253">
                    <span className="bg-indigo-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3254">
                      (6)
                    </span>
                    <div data-id="element-3255">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3256">
                        Violation Records
                      </p>
                      <p className="text-gray-700" data-id="element-3257">
                        Has prepared and furnished the motor carrier that
                        employs him/her with the list of violations or the
                        certificate as required by §391.27
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-orange-500 rounded-lg p-6" data-id="element-3258">
                  <div className="flex items-start" data-id="element-3259">
                    <span className="bg-orange-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3260">
                      (7)
                    </span>
                    <div data-id="element-3261">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3262">
                        Not Disqualified
                      </p>
                      <p className="text-gray-700" data-id="element-3263">
                        Is not disqualified to drive a commercial motor vehicle
                        under the rules in §391.15
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-teal-500 rounded-lg p-6" data-id="element-3264">
                  <div className="flex items-start" data-id="element-3265">
                    <span className="bg-teal-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3266">
                      (8)
                    </span>
                    <div data-id="element-3267">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3268">
                        Road Test Certification
                      </p>
                      <p className="text-gray-700" data-id="element-3269">
                        Has successfully completed a driver's road test and has
                        been issued a certificate of driver's road test in
                        accordance with §391.31, or has presented an operator's
                        license or certificate of road test which the motor
                        carrier has accepted as equivalent to a road test in
                        accordance with §391.33
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Requirements Summary */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3270">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3271">
              8 Key Qualification Requirements
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-3272">
              <div className="bg-white/10 rounded-lg p-4" data-id="element-3273">
                <p className="font-bold mb-1" data-id="element-3274">1. Age</p>
                <p className="text-sm text-gray-200" data-id="element-3275">At least 21 years old</p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3276">
                <p className="font-bold mb-1" data-id="element-3277">2. English Proficiency</p>
                <p className="text-sm text-gray-200" data-id="element-3278">
                  Read, speak, understand signs
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3279">
                <p className="font-bold mb-1" data-id="element-3280">3. Experience/Training</p>
                <p className="text-sm text-gray-200" data-id="element-3281">Safely operate CMV type</p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3282">
                <p className="font-bold mb-1" data-id="element-3283">4. Physical Qualifications</p>
                <p className="text-sm text-gray-200" data-id="element-3284">
                  Meet Subpart E requirements
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3285">
                <p className="font-bold mb-1" data-id="element-3286">5. Valid License</p>
                <p className="text-sm text-gray-200" data-id="element-3287">
                  One State/jurisdiction only
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3288">
                <p className="font-bold mb-1" data-id="element-3289">6. Violation Records</p>
                <p className="text-sm text-gray-200" data-id="element-3290">
                  Furnished to employer (§391.27)
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3291">
                <p className="font-bold mb-1" data-id="element-3292">7. Not Disqualified</p>
                <p className="text-sm text-gray-200" data-id="element-3293">Per §391.15 rules</p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3294">
                <p className="font-bold mb-1" data-id="element-3295">8. Road Test</p>
                <p className="text-sm text-gray-200" data-id="element-3296">
                  Certificate per §391.31/§391.33
                </p>
              </div>
            </div>
          </div>

          {/* Important Resources */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3297">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3298">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3299" />
              Important Resources
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-3300">
              <a href="http://www.fmcsa.dot.gov/documents/safetyprograms/Medical-Report.pdf" target="_blank" rel="noopener noreferrer" className="bg-blue-50 hover:bg-blue-100 border-2 border-blue-500 rounded-lg p-6 transition-colors group" data-id="element-3301">
                <div className="flex items-start mb-3" data-id="element-3302">
                  <FileText className="text-blue-600 mr-3 flex-shrink-0" size={24} data-id="element-3303" />
                  <h3 className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-3304">
                    Medical Examination Form
                  </h3>
                </div>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3305">
                  Official FMCSA medical examination form for commercial drivers
                </p>
                <div className="flex items-center text-blue-600 font-semibold" data-id="element-3306">
                  <span className="mr-2" data-id="element-3307">Download PDF</span>
                  <ExternalLink size={16} data-id="element-3308" />
                </div>
              </a>

              <a href="http://www.fmcsa.dot.gov/rules-regulations/topics/medical/exemptions.htm" target="_blank" rel="noopener noreferrer" className="bg-green-50 hover:bg-green-100 border-2 border-green-500 rounded-lg p-6 transition-colors group" data-id="element-3309">
                <div className="flex items-start mb-3" data-id="element-3310">
                  <FileText className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-3311" />
                  <h3 className="font-bold text-gray-900 group-hover:text-green-600 transition-colors" data-id="element-3312">
                    Driver Exemption Programs
                  </h3>
                </div>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3313">
                  Information on medical exemptions and waiver programs
                </p>
                <div className="flex items-center text-green-600 font-semibold" data-id="element-3314">
                  <span className="mr-2" data-id="element-3315">View Information</span>
                  <ExternalLink size={16} data-id="element-3316" />
                </div>
              </a>

              <a href="http://www.fmcsa.dot.gov/rules-regulations/topics/medical/spepackage.htm" target="_blank" rel="noopener noreferrer" className="bg-purple-50 hover:bg-purple-100 border-2 border-purple-500 rounded-lg p-6 transition-colors group" data-id="element-3317">
                <div className="flex items-start mb-3" data-id="element-3318">
                  <FileText className="text-purple-600 mr-3 flex-shrink-0" size={24} data-id="element-3319" />
                  <h3 className="font-bold text-gray-900 group-hover:text-purple-600 transition-colors" data-id="element-3320">
                    Skill Performance Evaluation (SPE)
                  </h3>
                </div>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3321">
                  SPE program for drivers with certain physical conditions
                </p>
                <div className="flex items-center text-purple-600 font-semibold" data-id="element-3322">
                  <span className="mr-2" data-id="element-3323">Learn More</span>
                  <ExternalLink size={16} data-id="element-3324" />
                </div>
              </a>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3325">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3326">Key Takeaways</h2>

            <div className="space-y-3" data-id="element-3327">
              <div className="flex items-start" data-id="element-3328">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3329" />
                <span data-id="element-3330">
                  All CMV drivers must be qualified under §391.11 requirements
                </span>
              </div>
              <div className="flex items-start" data-id="element-3331">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3332" />
                <span data-id="element-3333">Minimum age: 21 years old for interstate commerce</span>
              </div>
              <div className="flex items-start" data-id="element-3334">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3335" />
                <span data-id="element-3336">
                  English language proficiency required for safety communication
                </span>
              </div>
              <div className="flex items-start" data-id="element-3337">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3338" />
                <span data-id="element-3339">
                  Physical qualifications must meet Subpart E standards
                </span>
              </div>
              <div className="flex items-start" data-id="element-3340">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3341" />
                <span data-id="element-3342">Valid CDL from only one State or jurisdiction</span>
              </div>
              <div className="flex items-start" data-id="element-3343">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3344" />
                <span data-id="element-3345">Violation records must be furnished to employer</span>
              </div>
              <div className="flex items-start" data-id="element-3346">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3347" />
                <span data-id="element-3348">Must not be disqualified under §391.15</span>
              </div>
              <div className="flex items-start" data-id="element-3349">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3350" />
                <span data-id="element-3351">
                  Road test certification required (§391.31 or §391.33)
                </span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-3352">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3353">
              Need Help with Medical Certification?
            </h2>
            <p className="text-xl mb-6" data-id="element-3354">
              Expert guidance on DOT medical requirements and physical
              qualifications
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-3355">
              <Phone className="mr-3" size={24} data-id="element-3356" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-3357">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}